
import { defineComponent } from 'vue'
import Dropdown from 'primevue/dropdown'
import QBEAdvancedFilterDialogDescriptor from './QBEAdvancedFilterDialogDescriptor.json'
import QBEOperand from './QBEOperand.vue'

export default defineComponent({
    name: 'qbe-operator',
    components: { Dropdown, QBEOperand },
    props: { propNode: { type: String }, selected: { type: Boolean } },
    emits: ['selectedChanged', 'treeUpdated'],
    data() {
        return {
            QBEAdvancedFilterDialogDescriptor,
            node: { value: '' } as any
        }
    },
    watch: {
        propNode: {
            handler() {
                this.loadNode()
            },
            deep: true
        }
    },
    async created() {
        this.loadNode()
    },
    methods: {
        loadNode() {
            this.node = this.propNode as string
        }
    }
})
